import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useLang } from "../context";
import { POLICIES } from "../policies";

export default function Policy() {
  const { lang } = useLang();
  const { key } = useParams();
  const policy = POLICIES[key];
  if (!policy) return <Navigate to="/" replace />;

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-12 pb-10" data-testid={`policy-${key}`}>
      <p className="text-xs uppercase tracking-[0.3em] text-[#737373] mb-4">{policy.updated[lang]}</p>
      <h1 className="serif text-5xl lg:text-6xl mb-12">{policy.title[lang]}</h1>
      <div className="space-y-12">
        {policy.blocks[lang].map((b, i) => (
          <div key={b.h} className="border-l-2 border-[#1A1A1A]/15 pl-7">
            <h2 className="serif text-2xl mb-3">{b.h}</h2>
            <p className="text-base text-[#404040] leading-relaxed">{b.p}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
